import type { DocumentType } from "../../domain/entities/document"

export type PreviewKind =
  | "pdf"
  | "markdown"
  | "text"
  | "docx"
  | "spreadsheet"
  | "unsupported"

export const resolvePreviewKind = (
  name: string,
  documentType: DocumentType,
): PreviewKind => {
  const ext = name.includes(".")
    ? name.slice(name.lastIndexOf(".") + 1).toLowerCase()
    : ""

  switch (ext) {
    case "pdf":
      return "pdf"
    case "md":
    case "markdown":
      return "markdown"
    case "txt":
      return "text"
    // CSV is plain text — the existing <pre> branch renders it without a parser.
    case "csv":
      return "text"
    case "xlsx":
      return "spreadsheet"
    case "docx":
    case "doc":
      return "docx"
  }

  switch (documentType) {
    case "pdf":
      return "pdf"
    case "doc":
      return "docx"
    case "text":
      return "text"
    // A tabular document with no recognised extension is most likely an xlsx;
    // if the guess is wrong, the parse error falls back to the Download button.
    case "tabular":
      return "spreadsheet"
    default:
      return "unsupported"
  }
}
